import { empty, prepareResponseData } from "../Utilities/utils";

//api
import generalApi from "./General";

export const GetStudentData = async () => {
  try {
    const response = await generalApi.getStudentData();
    const response_data = prepareResponseData(response);
    if (empty(response_data) || empty(response_data.success)) {
      const statusCodeType = !empty(response_data.statusCodeType)
        ? response_data.statusCodeType
        : "";
      const error = { success: false, statusCodeType };
      return error;
    }

    const userDetails = !empty(response_data.response)
      ? response_data.response
      : {};

    return {
      success: true,
      response: userDetails,
    };
  } catch (error) {
    console.log(error);
    return { success: false, response: "Something went wrong." };
  }
};
